import styled from 'styled-components';

export const ReturnButtonWrapper = styled.div`
    margin-top: 24px;
`;
